export function getCleanPath(pathname) {
  let path = pathname ?? window.location.pathname;
  try {
    path = decodeURIComponent(path);
  } catch (_) {
    /* keep raw path */
  }
  return path.endsWith("/") && path.length > 1 ? path.slice(0, -1) : path;
}

const PUBLIC_PATHS = ["/", "/index.html", "/recurso-no-disponible"];

const PUBLIC_PREFIXES = [
  "/cursos",
  "/curso/",
  "/pago",
  "/checkout",
  "/NewRegistro",
  "/terminos",
  "/privacidad",
  "/recuperar-password",
  "/reset-password",
  "/check-email",
  "/verify-email",
  "/setup-account",
  "/login",
  "/invitar-pago",
];

export const isPublicPath = (cleanPath) =>
  PUBLIC_PATHS.includes(cleanPath) ||
  PUBLIC_PREFIXES.some((p) => cleanPath.startsWith(p));
